import request from '@/api/request'

export default {
    /**
     * 上传单个文件
     * @param {File} file - 文件对象
     * @param {Function} onProgress - 进度回调函数 (percent: number) => void
     * @returns {Promise}
     */
    uploadFile(file, onProgress) {
        const formData = new FormData();
        formData.append('file', file);

        return request({
            url: '/file/upload',
            method: 'post',
            data: formData,
            onUploadProgress: (progressEvent) => {
                if (onProgress && progressEvent.total > 0) {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    onProgress(percent, progressEvent);
                }
            }
        });
    },

    /**
     * 批量上传（可选）
     */
    uploadFiles(files, onProgress) {
        const formData = new FormData();
        files.forEach(file => {
            formData.append('files', file); // 注意字段名
        });

        return request({
            url: '/upload/files',
            method: 'post',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: onProgress
                ? (progressEvent) => {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    onProgress(percent, progressEvent);
                }
                : undefined
        });
    }
};